import makeService from '@/tools/makeService.js';
import req from './request.config.js';
import {url} from "./link";
import store from '../store/index.js';


var service = {
    /*自动生成方法*/

};

makeService(url, service, req);

export default service;
